import {
  CostingProfileDetailsPage,
  CostingProfileListPage,
  PricingProfileDetailsPage,
  PricingProfileListPage,
} from 'pricing/pages';

import {
  costingProfileDetailsPath,
  costingProfileListPath,
  pricingProfileDetailsPath,
  pricingProfileListPath,
} from './routePaths';

export const pricingProfiles = {
  path: pricingProfileListPath(),
  exact: true,
  isPrivate: true,
  element: <PricingProfileListPage />,
};

export const pricingProfile = {
  path: pricingProfileDetailsPath(),
  exact: true,
  isPrivate: true,
  element: <PricingProfileDetailsPage />,
};

export const costingProfiles = {
  path: costingProfileListPath(),
  exact: true,
  isPrivate: true,
  element: <CostingProfileListPage />,
};

export const costingProfile = {
  path: costingProfileDetailsPath(),
  exact: true,
  isPrivate: true,
  element: <CostingProfileDetailsPage />,
};
